import { render, staticRenderFns } from "./BookLogout.vue?vue&type=template&id=4896c351&scoped=true&"
import script from "./BookLogout.vue?vue&type=script&lang=js&"
export * from "./BookLogout.vue?vue&type=script&lang=js&"
import style0 from "./BookLogout.vue?vue&type=style&index=0&id=4896c351&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4896c351",
  null
  
)

export default component.exports